module.exports = __webpack_public_path__ + "img/history-circle.0e474852.svg";